module.exports = __webpack_public_path__ + "img/21-03.bd4b07f7.png";